// App-wide constants

// localStorage keys
export const STORAGE_KEYS = {
  REFRESH_TOKEN: "refreshToken",
  TILL_ID: "tiilId",
  TILL_NAME: "tillName",
  TILL_DATA: "tillData",
  TILL_DATA_OWNER: "tillDataOwner",
  TILL_VALUE: "tillValue",
  USER_PREFERENCES: "userPreferences",
  SELECTED_LANGUAGE: "selectedLanguage",
  STATES_DATA: "statesData",
  COUNTRIES_DATA: "countriesData",
  LAST_UPDATED_TIME: "lastUpdatedTime",
  POS_SCAN_CONFIGURATIONS: "posScanConfigurations",
  DEVICE_ID: "kds_device_id",
};

// Default user preferences
export const DEFAULT_USER_PREFERENCES = {
  dateFormat: "DD-MM-YYYY",
  dateTimeFormat: "DD-MM-YYYY HH:mm:ss",
};

// Supported languages
export const LANGUAGES = {
  English: "English",
  Arabic: "Arabic",
  French: "French",
  Hindi: "Hindi",
};

// Max notification count
export const MAX_VISIBLE_NOTIFICATIONS = 1;
